import {
  DOWNLOAD_CATEGORIES_CHECKBOX_CHANGED,
  DOWNLOAD_RADIO_CHANGED,
  DELETE_LINE_SELECTION_RADIO_CHANGED
} from "./types";

export const handleCheckboxChange = ({ target: { value } }) => (dispatch, getState) => {
  const checkboxInformation = [...getState().downloadInputInformation.downloadCategories];

  checkboxInformation.map(item => {
    if (item.category_id === value) {
      item.checked = !item.checked;
    }
    return item;
  });

  dispatch({
    type: DOWNLOAD_CATEGORIES_CHECKBOX_CHANGED,
    payload: checkboxInformation
  });
};

export const handleRadioChange = ({ target: { value, name } }) => dispatch => {
  if (name === "sensitivitySelection") {
    if (value === "standard") {
      value = "REGULAR";
    } else {
      value = "AFFIDAVIT";
    }
  }
  const payload = {
    [name]: value
  };

  dispatch({
    type: DOWNLOAD_RADIO_CHANGED,
    payload
  });
};

export const handleDeleteRadioChange = value => dispatch => {
  const payload = value;

  dispatch({
    type: DELETE_LINE_SELECTION_RADIO_CHANGED,
    payload
  });
};
